<template>
  <div class="studentQuesMessage">
    <div class="content">
      <studentMessage :form="form"></studentMessage>
    </div>
  </div>
</template>

<script>
import studentMessage from '@/components/consultant/ques/studentMessage.vue'
export default {
  name: "parentMessage.vue",
  components: {
    studentMessage
  },
  data() {
    return {
      studentId: sessionStorage.getItem('myStudentStudentId'),
      form :{
        name: '',//姓名
        sex: '',//性别 1男2女
        nation:'',//民族
        hometown: '',//籍贯
        gaoYear: 2020,//高考年份
        subject: '',//高考科类
        birth: null,//出生年月
        school: '',//学校
        class: '',//班级
        stressClass: '',//重点班级 1是 2否
        classPosition: '',//班级职务
        inSchool: '',//是否住校 1走读 2住校
        homeAddress: '',//家庭住址
        grade: '',//高考年份对应的年级

        // 家庭基本信息
        motherName: '', //母亲姓名
        motherWork: '', //工作单位
        motherPost: '', //职务
        motherEducation: '', //学历
        motherPhone: '', //联系方式
        fatherName: '', //父亲姓名
        fatherWork: '', //工作单位
        fatherPost: '', //职务
        fatherEducation: '', //学历
        fatherPhone: '', //联系方式
        remarks: '', //备注



        //学习现状部分
        learningGoal: '',// 你给自己制定学习目标了吗，如何看待你的目标？
        learningTime: '',// 你能自己安排的时间有哪些？比如自习时间，会怎么分配时间？
        learningPlan: '',// 你有制定学习计划的习惯吗，你会每天制定学习计划吗？
        learningTrouble: '',// 在记忆和背诵知识点方面你是否存在困扰？具体描述一下你的困扰。

        learningPreview: '',// 预习情况
        learningClass: '',// 课堂效果
        learningNote: '',// 课堂笔记
        learningReview: '',// 复习情况
        learningHomework: '',// 每天的作业练习，遇到不懂的题目，你是当天一定要想办法解决掉，还是以后再说？
        learningArrange: '',// 你会定期梳理所学知识，并进行总结和归纳吗，你认为自己的总结归纳能力如何？
        learningWrong: '',// 你有整理错题的习惯吗？你是如何整理错题的？

        learningExam: '',// 考试情况
        learningGrade: '',// 学习成绩
        learningLookGoal: '',// 你给自己制定学习目标了吗，如何看待你的目标？
        learningTerm: '',//学期
        learningYuekao: '',//月考
        learningYearPeople: '',//人数
        learningGradeArr:[
          { subject: '语文',grade: '', rank: ''},
          { subject: '数学',grade: '', rank: ''},
          { subject: '外语',grade: '', rank: ''},
          { subject: '物理',grade: '', rank: ''},
          { subject: '化学',grade: '', rank: ''},
          { subject: '生物',grade: '', rank: ''},
          { subject: '历史',grade: '', rank: ''},
          { subject: '政治',grade: '', rank: ''},
          { subject: '地理',grade: '', rank: ''},
        ],

        // learningLikeRank: Array(9).fill('')
        learningLikeRank: [
        ],


        learningGoodRank:[
        ],

        learningTeacherRank:[
        ],

        // 学习动力部分
        learningPower: '',//对我来说，学习过程中的动力有什么？
        learningFeel: '',//你喜欢学习吗，在学习过程中你的感受是怎样的？描述一下你的感受
        learningHinder: '',//对我来说，学习过程中的阻碍有什么
        learningMaxHinder: '',//其中最大的阻碍是：
        learningSolveHinder: '',//我认为这种阻碍可以解决的程度是
        learningSolveLiyou: '',//我认为这种阻碍可以解决的程度是（理c由）
        learningPotential: '',//我认为自己的信息发展潜力如何
        learningPotentialLiyou: '',//我认为自己的信息发展潜力如何（理由）

        // 个人信息部分 my
        myClub: '',//我参加的社团
        myHobby: '',//我的兴趣爱好
        mySpecialty: '',//我的特长优势
        myShortcomings: '',//我的缺点不足
        myBestFriend: '',//我最好的朋友
        myLikeBook: '',//喜欢的书
        myLikeMovie: '',//喜欢的电影
        myLikeStar: '',//喜欢的明星
        myWish: '',//我的愿望
        myLikeCareer: '',//我向往的职业
        myLikeMajor: '',//我向往的专业
        myLikeUniversity: '',//我向往的大学
        myAccomplishment: '',//最近做过让自己很有成就感的事
        myUpset: '',//我最近的烦恼
        myWantLife: '',//我未来想过的生活


        // 个人成就部分
        isAwarded: '',//是否曾经获得过市级及以上奖励（如三好学生，优秀干部等）
        awarded: [{
          key: 1,
          name: '',//获奖名称
          year: '',//获奖年份
          grade: ''//奖励级别
        }],
        isWantOtherWay: '',//是否对高考统招之外其他路径做过了解并有参与的意愿
        otherWayList: [],

        // 学业规划意愿
        studyWill: '',//我认为科学、系统、完整的学习规划，对学习及个人发展有什么好处：
        // 其他部分
        otherHelp: '',//希望获得哪些方面的帮助：
        otherDescription: '',//其他说明
      },
    }
  },
  created() {
    this.getStudentCensusQuestionByStudent();
  },
  methods: {
    checkTime(i) {
      if (i < 10) {
        i = '0' + i
      }
      return i
    },
    switchTimeFormat(time) {
      let date = new Date(time);
      return date.getFullYear() + '-' + this.checkTime(date.getMonth() + 1) + '-' + this.checkTime(date.getDate())
    },
    getStudentCensusQuestionByStudent () {
      let studentId = this.studentId;
      this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.getStudentCensusQuestion,{
        studentId: studentId
      },{
        headers:{
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then((res)=>{
        if(res.data.code==2000){
          let data = res.data.data;
          let censusQuestion = data.censusQuestion;
          this.status = data.status;
          if(censusQuestion) {
            this.form = censusQuestion;
          }else {
            let form = this.form;
            form.gaoYear = data.gaoYear;
            form.name = data.name;
            form.school = data.schoolName;
            form.sex = data.sex;
            this.form = form;
          }
        }else{
          this.$message({
                    message: res.data.msg,
                    type: 'error'
          });
        }
      })
    },
  }
}
</script>
<style scoped lang="less">
.studentQuesMessage {
  .content {
    background-color: #fff;
    padding: 20px;
    min-height: 600px;
  }
}
</style>